import { FC } from 'react'
import cn from 'classnames'

import { LoanStatus } from 'pages/account/loans/utils'

import { EarnStatus } from 'pages/account/savings/utils'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

export type Status = LoanStatus | EarnStatus

export enum EZones {
  GREEN = 'green',
  ORANGE = 'orange',
  RED = 'red',
}

interface Props {
  statuses: Status[]
  selectedStatuses: Status[]
  onSelect: (status: Status, zone?: EZones | EZones[]) => void
  isLoan?: boolean
  selectedZones?: EZones[]
}

const StatusList: FC<Props> = ({ statuses, selectedStatuses, onSelect, isLoan, selectedZones }) => {
  const { t } = useTranslation()

  return (
    <div className={cn(styles.container)}>
      <div className={styles.list}>
        {statuses.map((cur) => (
          <>
            <label className={styles.listItem} key={cur}>
              <input
                type="checkbox"
                checked={
                  isLoan && cur === LoanStatus.Active
                    ? selectedStatuses.includes(cur) && selectedZones.length > 0
                    : selectedStatuses.includes(cur)
                }
                onChange={() => onSelect(cur)}
              />
              <p>{t(cur.toLowerCase())}</p>
            </label>
            {isLoan && cur.toLowerCase() === 'active' && (
              <>
                <label className={cn(styles.listItem, styles.sublist)} key={cur + EZones.GREEN}>
                  <input
                    type="checkbox"
                    checked={selectedZones.includes(EZones.GREEN)}
                    onChange={() => onSelect(cur, EZones.GREEN)}
                  />
                  <p>{t('active_in')} <span className={styles.green}>{t('green_capital')} </span>{t('zone_info')}</p>
                </label>

                <label className={cn(styles.listItem, styles.sublist)} key={cur + EZones.ORANGE}>
                  <input
                    type="checkbox"
                    checked={selectedZones.includes(EZones.ORANGE)}
                    onChange={() => onSelect(cur, EZones.ORANGE)}
                  />
                  <p>{t('active_in')} <span className={styles.orange}>{t('orange_capital')} </span>{t('zone_info')}</p>
                </label>

                <label className={cn(styles.listItem, styles.sublist)} key={cur + EZones.RED}>
                  <input
                    type="checkbox"
                    checked={selectedZones.includes(EZones.RED)}
                    onChange={() => onSelect(cur, EZones.RED)}
                  />
                  <p>{t('active_in')} <span className={styles.red}>{t('red_capital')} </span>{t('zone_info')}</p>
                </label>
              </>
            )}
          </>
        ))}
      </div>
    </div>
  )
}

export default StatusList
